module.exports = __webpack_public_path__ + "img/instegram.20c3099a.svg";